import { render, staticRenderFns } from "./ContactsOverview.vue?vue&type=template&id=8ba9dcdc&scoped=true&"
import script from "./ContactsOverview.vue?vue&type=script&lang=js&"
export * from "./ContactsOverview.vue?vue&type=script&lang=js&"
import style0 from "./ContactsOverview.vue?vue&type=style&index=0&id=8ba9dcdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba9dcdc",
  null
  
)

export default component.exports